import React from 'react'
import CloseIcon from '../../common/icons/CloseIcon'

const PaneHeader = ({ icon, title, onClose }) => {
  const renderIcon = () => {
    if (!icon) return null
    if (typeof icon === 'string') {
      return (
        <span
          className='pane-header__icon-svg'
          style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
          dangerouslySetInnerHTML={{ __html: icon }}
        />
      )
    }
    if (React.isValidElement(icon)) {
      return icon
    }
    const IconComponent = icon
    return <IconComponent />
  }

  return (
    <div className='pane-header'>
      <div className='pane-header__left'>
        {icon && (
          <div className='pane-header__badge'>
            {renderIcon()}
          </div>
        )}
        <h2 className='pane-header__title'>{title}</h2>
      </div>
      {onClose && (
        <button
          type='button'
          className='pane-header__close'
          onClick={onClose}
          aria-label='Close'
        >
          <CloseIcon />
        </button>
      )}
    </div>
  )
}

export default PaneHeader
